"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6160,9849],{

/***/ 59849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgZoom = function SvgZoom(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    width: 32,
    height: 32,
    y: 0.293,
    fill: "#9b7b6f",
    rx: 5
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M16.539 24.465H24v-7.462h-1.59v4.498l-4.498-4.498-1.373 1.373 4.498 4.499h-4.498v1.59ZM15.461 8.293H8v7.462h1.59v-4.499l4.498 4.499 1.373-1.374-4.498-4.498h4.498v-1.59Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgZoom);

/***/ }),

/***/ 76160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ multimedia_Iframe; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(60123);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./public/assets/icons/zoom.svg
var zoom = __webpack_require__(59849);
;// CONCATENATED MODULE: ./components/atoms/multimedia/Iframe/Iframe.tsx







var PopUpIframe = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5518), __webpack_require__.e(8230)]).then(__webpack_require__.bind(__webpack_require__, 48230));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48230)
            ];
        }
    },
    ssr: true
});
/**
 * Iframe
 */ var Iframe = function(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, src = _param.src, popUp = _param.popUp, descPopUp = _param.descPopUp, popUpTitle = _param.popUpTitle, isYoutube = _param.isYoutube, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "src",
        "popUp",
        "descPopUp",
        "popUpTitle",
        "isYoutube"
    ]);
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var showGallery = function() {
        setOpen(!open);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            popUp && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpIframe, (0,_object_spread/* default */.Z)({
                        title: popUpTitle,
                        src: src,
                        setState: setOpen,
                        state: open,
                        desc: descPopUp
                    }, props)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute right-3 top-3 z-10 h-8 w-8 cursor-pointer",
                        onClick: showGallery,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zoom["default"], {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                src: src
            }, isYoutube && {
                allowFullScreen: true,
                mozallowFullScreen: true,
                msallowFullScreen: true,
                oallowFullScreen: true,
                webkitAllowFullScreen: true
            }, props), {
                className: "h-full w-full border-none ".concat(className)
            }))
        ]
    });
};
Iframe.displayName = "Iframe";

;// CONCATENATED MODULE: ./components/atoms/multimedia/Iframe/index.ts

/* harmony default export */ var multimedia_Iframe = (Iframe);


/***/ })

}]);